import React, { useState, useEffect, useContext, useMemo } from "react";

import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid, Container, Typography } from '@material-ui/core';

import AirportsService from '../../services/airports.servicse';
import ConstantsService from '../../services/constants.service';
import FlightsService from '../../services/flights.servicse';
import TextfieldEnLetters from '../FormsUI/TextfieldEnLetters';
import TextfieldGeneral from '../FormsUI/TextfieldGeneral';
import DateTimePickerFormsUI from '../FormsUI/DateTimePicker';
import TextfieldEnEmail from '../FormsUI/TextfieldEnEmail';
import TextfieldPhone from '../FormsUI/TextfieldPhone';
import AppSelectFormik from "components/formik/AppSelectFormik";
import { filterOptions } from "utils/common-utils";
import AuthContext from "store/AuthContext";
import AppButton from 'components/FormsUI/AppButton/appButton';
import ToastContext from "store/ToastContext";

function NewFlightPopup(props) {
    const MAX_OPTIONS = 50;
    const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [errMessage, setErrMessage] = useState("");
    const [airportsOptions, setAirportsOptions] = useState([]);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    
    useEffect(() => {
            AirportsService.getAirportsOptions().then(setAirportsOptions)
    }, [])

    const handleSubmit = async (values) => {

        setSpinnerLoading(true);
        setErrMessage(undefined);

        var isValid = true;

        if (values.departureAirport && values.arrivalAirport) {

            if (values.arrivalAirport.value === values.departureAirport.value) {
                isValid = false
                setErrMessage("Departure Airport and Arrival Airport Are identical. Please select another Departure/Arrival airport");
                setSpinnerLoading(false);
                return;
            }
            else if (values.arrivalAirport.countryCode === "ISR" && values.departureAirport.countryCode === "ISR") {
                isValid = false
                setErrMessage("must be in Israel Departure Airport or Arrival Airport");
                setSpinnerLoading(false);
                return;
            }
            else if (values.arrivalAirport.countryCode !== "ISR" && values.departureAirport.countryCode !== "ISR") {
                isValid = false;
                setErrMessage("Departure Airport or Arrival Airport must be in Israel");
                setSpinnerLoading(false);
                return;
            }
        }

        var FlightFutureInterval = sessionStorage.getItem('FlightFutureInterval');
        var FlightOffsetInterval = sessionStorage.getItem('FlightOffsetInterval');

        if (FlightFutureInterval === null || FlightOffsetInterval === null) {
            var constants = await ConstantsService.getConstants();
            constants.forEach(element => {
                if (FlightOffsetInterval === null) {
                    if (element.constantName === "FlightOffsetInterval") {
                        FlightOffsetInterval = element.constantValue;
                        sessionStorage.setItem('FlightOffsetInterval', element.constantValue);
                    }
                }
                if (FlightFutureInterval === null) {
                    if (element.constantName === "FlightFutureInterval") {
                        FlightFutureInterval = element.constantValue;
                        sessionStorage.setItem('FlightFutureInterval', element.constantValue)
                    }
                }
            });
        }


        var currentDate = new Date();
        var minDate = new Date(currentDate.getTime() - parseInt(FlightOffsetInterval) * 60000);//decrese 30 minutes from date
        var maxDate = new Date(new Date(currentDate).setHours(currentDate.getHours() + parseInt(FlightFutureInterval)));//add 30 hours to date
        var convertedFlightDateTime = new Date(values.flightDateTime);

        if (convertedFlightDateTime < minDate || convertedFlightDateTime > maxDate) {
            isValid = false;
            setErrMessage("Flight Date and Time must be in the range of " +
                minDate + " and " + maxDate);
        }


        if (!isValid) { 
            setSpinnerLoading(false);
        }
        else if (isValid) {
            if (values.departureAirport.countryCode === "ISR") { values.direction = 2; }
            if (values.arrivalAirport.countryCode === "ISR") { values.direction = 1; }

            values.airlineCode = userInfo.airlineCode;
            values.airlineId = userInfo.airline.airlineId;

            var isFlightExsist = await FlightsService.findFlightBeforeAdd(values);
            if (isFlightExsist !== null) {
                openToast("Flight already exists", "error", {duration: 8000});
                setSpinnerLoading(false);
            } else {
                var addFlight = await FlightsService.addData(values);
                if (addFlight.code === 0) {
                    openToast("Flight added", "success")
                    props.onSubmitted({id: addFlight.description}, "Add");
                } else {
                    openToast("Error occurred, flight not added.", "error", {duration: 8000})
                    setSpinnerLoading(false);
                }
            }
        }
    }

    const airportsFilter = (inputVal) => 
        new Promise(res => res(filterOptions(inputVal, airportsOptions, MAX_OPTIONS)))

    const airportsDefaultOptions = useMemo(() => filterOptions('', airportsOptions, MAX_OPTIONS)
        ,[airportsOptions]);

    const today = new Date();

    return (
        <Grid container>
            <Grid item xs={12}>
                <Container maxWidth="md">
                    <div>
                        <Formik
                            initialValues={{
                                flightCode: props.flight?.flightCode ? props.flight?.flightCode : '',
                                flightDateTime: props.flight?.flightDateTime ? props.flight?.flightDateTime : new Date(),
                                departureAirport: null,
                                arrivalAirport: null,
                                contactFirstName: props.flight?.firstName ? props.flight?.firstName : userInfo.firstName,
                                contactLastName: props.flight?.lastName ? props.flight?.lastName : userInfo.lastName,
                                contactPhone: props.flight?.phoneNumber ? props.flight?.phoneNumber : userInfo.phoneNumber,
                                contactFaxNo: props.flight?.faxNumber ? props.flight?.faxNumber : userInfo.faxNumber,
                                contactEmail: props.flight?.email ? props.flight?.email : userInfo.email
                            }}
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(true);
                                handleSubmit(values);
                            }}
                            validationSchema={Yup.object().shape({
                                flightCode: Yup.string().required('Flight code is required'),
                                flightDateTime: Yup.date().required('Flight Date Time is required')
                                    .min(today, 'Date cannot be in the past')
                                    .test('len', 'Year must be exactly 4 characters',
                                        val => val && val.getFullYear().toString().length === 4),
                                contactFirstName: Yup.string().required('Contact first name is required')
                                    .matches(/^[a-zA-Z- ]+$/, "Invalid input format"),
                                contactLastName: Yup.string().required('Contact lastt name is required')
                                   .matches(/^[a-zA-Z- ]+$/, "Invalid input format"),
                                contactPhone: Yup.string().required('Contact phone is required')
                                    .matches(/^\+(?:[0-9]?){6,14}[0-9]$/, 'Invalid input format'),
                                contactEmail: Yup.string().required('Contact email is required').email('Invalid input format'),
                                departureAirport: Yup.object().shape({value: Yup.string().required()}).nullable().required('Required *'),
                                arrivalAirport: Yup.object().shape({value: Yup.string().required()}).nullable().required('Required *'),
                            })}
                        >
                            {(props) => {
                                const {
                                    //values,
                                    handleSubmit,
                                } = props;
                                return (
                                    <Form onSubmit={handleSubmit} noValidate>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextfieldGeneral name="flightCode" label="Flight Code" size="small" inputProps={{maxLength: 8}} id="flightCode" InputLabelProps={{id:"flightCodeLabel"}}></TextfieldGeneral>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <DateTimePickerFormsUI name="flightDateTime" label="Flight Date Time" size="small" id="flightDateTime" InputLabelProps={{id:"flightDateTimeLabel"}}/>
                                            </Grid>
                                            <Grid item xs={12} className="py-0">
                                                <AppSelectFormik
                                                    defaultOptions={airportsDefaultOptions}
                                                    name="departureAirport"
                                                    placeholder='Departure'
                                                    isClearable={true}
                                                    loadOptions={airportsFilter}
                                                    label="Departure"
                                                    labelId="departureLabel"
                                                    {...props}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className="py-0">
                                                <AppSelectFormik
                                                    defaultOptions={airportsDefaultOptions}
                                                    name="arrivalAirport"
                                                    placeholder='Arrival'
                                                    isClearable={true}
                                                    loadOptions={airportsFilter}
                                                    label="Arrival"
                                                    labelId="arrivalLabel"
                                                    {...props}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography id="contactInfo">Contact information</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldEnLetters className="ButtonLevelPosition" name="contactFirstName" label="Contact First Name" size="small"
                                                    id="contactFirstName" InputLabelProps={{id:"contactFirstNameLabel"}}
                                                ></TextfieldEnLetters>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldEnLetters className="ButtonLevelPosition" name="contactLastName" label="Contact Last Name" size="small"
                                                    id="contactLastName" InputLabelProps={{id:"contactLastNameLabel"}}
                                                ></TextfieldEnLetters>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldPhone className="ButtonLevelPosition" name="contactPhone" label="Contact phone" size="small"
                                                    id="contactPhone" InputLabelProps={{id:"contactPhoneLabel"}}
                                                ></TextfieldPhone>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldPhone className="ButtonLevelPosition" name="contactFaxNo" label="Contact Fax No" size="small"
                                                    id="contactFaxNo" InputLabelProps={{id:"contactFaxNoLabel"}}
                                                ></TextfieldPhone>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldEnEmail className="ButtonLevelPosition" name="contactEmail" label="contact email" size="small"
                                                    id="contactEmail" InputLabelProps={{id:"contactEmailLabel"}}
                                                ></TextfieldEnEmail>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {(errMessage !== "" && errMessage !== undefined) ? <div className="alert alert-danger">{errMessage}</div> : null}
                                            </Grid>
                                            <Grid container className="mb-2 px-2">
                                                <Grid item xs></Grid>
                                                <Grid item xs={2}>
                                                <AppButton id="addFlightBtn" type="submit" isLoading={spinnerLoading} label="SUBMIT" 
                                                    isBlock={true}
                                                ></AppButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </div>
                </Container>
            </Grid>
        </Grid>

    

    )
}
export default NewFlightPopup;